import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import { isOS } from '@/utils/constant'
// import Cookies from 'js-cookie'
// 引入element-ui 自带组件的国际化 （ICAS暂支持中文简体，中文繁体，英文，其他语言用暂时由英文代替）
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui - 英文
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui - 中文简体
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'// element-ui - 中文繁体
import elementJaLocale from 'element-ui/lib/locale/lang/ja'// element-ui - 日语
import elementKoLocale from 'element-ui/lib/locale/lang/ko'// element-ui - 韩语
import elementThLocale from 'element-ui/lib/locale/lang/th'// element-ui - 泰语
import elementViLocale from 'element-ui/lib/locale/lang/vi'// element-ui - 越南语
import elementIdLocale from 'element-ui/lib/locale/lang/id'// element-ui - 越南语

// 引入业务相关的国际化
import enLocale from './en'
import zhCNLocale from './zh-CN'
import zhHKLocale from './zh-HK'
// 其他语言的翻译暂时用英文代替
import jaLocale from './ja-JP' // 日语
import koLocale from './ko-KR' // 韩语
import thLocale from './th-TH' // 泰语
import viLocale from './vi-VN' // 越南语
import myLocale from './ms-MY' // 越南语

import enOSLocale from './os/en'
import zhCNOSLocale from './os/zh-CN'
import zhHKOSLocale from './os/zh-HK'
// 其他语言的翻译暂时用英文代替
import jaOSLocale from './os/ja-JP' // 日语
import koOSLocale from './os/ko-KR' // 韩语
import thOSLocale from './os/th-TH' // 泰语
import viOSLocale from './os/vi-VN' // 越南语
import myOSLocale from './os/ms-MY' // 越南语

import idOsLocale from './os/id-ID' // 印尼

Vue.use(VueI18n)

const isOS = () => {
  return window._global.CURRENT_SITE === 'OS'
}

if (isOS() === true) {
  enOSLocale['__origin__'] = enLocale
  zhCNOSLocale['__origin__'] = zhCNLocale
  zhHKOSLocale['__origin__'] = zhHKLocale
  jaOSLocale['__origin__'] = jaLocale
  koOSLocale['__origin__'] = koLocale
  thOSLocale['__origin__'] = thLocale
  viOSLocale['__origin__'] = viLocale
  myOSLocale['__origin__'] = myLocale
  idOsLocale['__origin__'] = idOsLocale
}

const enLocal = isOS() === true ? (enOSLocale) : (enLocale)
const zhCNLocal = isOS() === true ? (zhCNOSLocale) : (zhCNLocale)
const zhHKLocal = isOS() === true ? (zhHKOSLocale) : (zhHKLocale)
const jaLocal = isOS() === true ? (jaOSLocale) : (jaLocale)
const koLocal = isOS() === true ? (koOSLocale) : (koLocale)
const thLocal = isOS() === true ? (thOSLocale) : (thLocale)
const viLocal = isOS() === true ? (viOSLocale) : (viLocale)
const myLocal = isOS() === true ? (myOSLocale) : (myLocale)

const messages = {
  'en': {
    ...enLocal,
    ...elementEnLocale
  },
  'zh-CN': {
    ...zhCNLocal,
    ...elementZhCNLocale
  },
  'id-ID': {
    ...idOsLocale,
    ...elementIdLocale
  },
  'zh-HK': {
    ...zhHKLocal,
    ...elementZhTWLocale
  },
  'ja-JP': {
    ...jaLocal,
    ...elementJaLocale
  },
  'ko-KR': {
    ...koLocal,
    ...elementKoLocale
  },
  'th-TH': {
    ...thLocal,
    ...elementThLocale
  },
  'vi-VN': {
    ...viLocal,
    ...elementViLocale
  },
  'ms-MY': {
    ...myLocal,
    ...elementEnLocale
  }
}

// export const keysOfIn18 = Object.keys(messages)
export function getLanguage() {
  // const chooseLanguage = Cookies.get('lang')
  // if (chooseLanguage) return chooseLanguage

  // 默认语言设置
  // const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  // const locales = Object.keys(messages)
  // for (const locale of locales) {
  //   const val = locale.toLowerCase()
  //   if (language.indexOf(val) > -1) {
  //     return locale
  //   }
  // }
  // 默认中文
  return 'zh-CN'
}
const i18n = new VueI18n({
  // 默认设置 en | zh
  locale: getLanguage(),
  messages
})

export default i18n
